import React from 'react';

// Parses a small markdown-like syntax into React nodes:
//   **bold**       -> <strong>bold</strong>
//   *italic*       -> <em>italic</em>
//   __underline__  -> <u>underline</u>
//
// Safe: operates on plain strings; the resulting nodes are real React
// elements (no dangerouslySetInnerHTML), so XSS is not a concern.

const TOKEN_REGEX = /(\*\*[^*]+\*\*|__[^_]+__|\*[^*]+\*)/g;

export const renderRichText = (text) => {
  if (text == null) return null;
  const parts = String(text).split(TOKEN_REGEX);

  return parts.map((part, idx) => {
    if (!part) return null;

    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={idx}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('__') && part.endsWith('__') && part.length > 4) {
      return <u key={idx}>{part.slice(2, -2)}</u>;
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={idx}>{part.slice(1, -1)}</em>;
    }
    return <React.Fragment key={idx}>{part}</React.Fragment>;
  });
};
